import { getTaskPriorityColor } from "utils/taskUtils";

const PriorityBadge = ({ priority, size = "md", className = "" }) => {
  const sizeClasses = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center rounded-md font-semibold capitalize whitespace-nowrap ${sizeClasses} ${getTaskPriorityColor(
        priority
      )} ${className}`}
    >
      {priority || "N/A"}
    </span>
  );
};

export default PriorityBadge;
